import { getAppSettings } from '../../Util/globalAppSettings';
import { type RoadStatusLayerOptions } from '../Layers/Layers.types';
import { RoadStatusLayer } from '../Layers/RoadStatusLayer';
import { renameUserMapLayer } from '../UserSettings';
import { travelTime } from './TravelTime';
import { travelTimeV2 } from './TravelTimeV2';

export type TravelTimeLayerId = 'travel-time' | 'travel-time-v2';

/** True when the TomTom-fed v2 travel-time layer should be used instead of v1. */
const shouldUseTomTom = (): boolean => getAppSettings().enableTomtomRouteMonitoringApi;

/**
 * The active travel-time layer id, selected by the TomTom feature flag. Keeps
 * every page map consistent so only one travel-time variant is ever loaded.
 */
export const getTravelTimeLayerId = (): TravelTimeLayerId => (shouldUseTomTom() ? 'travel-time-v2' : 'travel-time');

/** Creates the active travel-time layer (v2 when the TomTom flag is on, else v1). */
export const createTravelTimeLayer = (region: string, options?: RoadStatusLayerOptions): RoadStatusLayer =>
    shouldUseTomTom() ? travelTimeV2(region, options) : travelTime(region, options);

/**
 * Migrates a persisted travel-time selection to the id the feature flag now uses,
 * so a user who had the layer toggled on/off keeps that choice after the flag
 * flips the layer variant.
 */
export const migrateTravelTimeUserLayer = (area: string): void =>
    shouldUseTomTom() ? renameUserMapLayer(area, 'travel-time', 'travel-time-v2') : renameUserMapLayer(area, 'travel-time-v2', 'travel-time');
